module.exports = __webpack_public_path__ + "components/Modals/SideDescription/img/POIgeneric.jpg?3ecc20e5";


//////////////////
// WEBPACK FOOTER
// ./components/Modals/SideDescription/img/POIgeneric.jpg
// module id = 2425
// module chunks = 0